export default __webpack_public_path__ + "static/d10-814cabf4dfb56677294ffcc9b23c166a.png";